import React, { useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ASSETS, BRAND } from "../../lib/api";
import { LayoutDashboard, Package, ShieldCheck, Users, ScrollText, ScanLine, LogOut, Plus, BookOpen } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, perm: null, end: true },
  { to: "/admin/shipments", label: "Shipments", icon: Package, perm: null },
  { to: "/admin/shipments/new", label: "New Shipment", icon: Plus, perm: "can_create_shipments" },
  { to: "/scan", label: "Scanner", icon: ScanLine, perm: null },
  { to: "/admin/roles", label: "Roles", icon: ShieldCheck, perm: "can_manage_roles" },
  { to: "/admin/users", label: "Users", icon: Users, perm: "can_manage_users" },
  { to: "/admin/audit", label: "Audit Log", icon: ScrollText, perm: "can_view_audit_log" },
  { to: "/help", label: "Help & Manuals", icon: BookOpen, perm: null },
];

export default function AdminLayout() {
  const { user, perms, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div data-testid="admin-layout" className="min-h-screen flex flex-col lg:flex-row" style={{ background: "#F5EFE0" }}>
      {/* Sidebar */}
      <aside className="lg:w-64 lg:min-h-screen border-r border-[#1B3022]/15 bg-[#0F1D14] text-[#F5EFE0]">
        <div className="p-5 border-b border-[#D4AF37]/30">
          <Link to="/" className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="HBS" className="h-12 w-12 object-contain bg-white rounded-sm p-1" />
            <div>
              <div className="font-serif-bv text-xl tracking-widest text-[#D4AF37]">{BRAND.short}</div>
              <div className="text-[9px] tracking-[0.25em] uppercase text-[#F5EFE0]/60">Operations</div>
            </div>
          </Link>
        </div>
        <nav className="p-3 space-y-1">
          {NAV.filter((i) => !i.perm || perms[i.perm]).map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setOpen(false)}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${
                    isActive ? "bg-[#D4AF37] text-[#0F1D14] font-medium" : "text-[#F5EFE0]/85 hover:bg-[#1B3022]"
                  }`
                }
              >
                <Icon size={16} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="absolute bottom-0 left-0 lg:relative lg:mt-auto p-4 border-t border-[#D4AF37]/20 w-full lg:w-64">
          <div className="text-xs text-[#F5EFE0]/70 mb-2 truncate">{user?.email}</div>
          <div className="text-[10px] tracking-widest uppercase text-[#D4AF37]/70 mb-3">{user?.role}</div>
          <button onClick={logout} data-testid="admin-logout" className="w-full btn-outline-gold rounded-sm py-2 text-xs flex items-center justify-center gap-2">
            <LogOut size={12} /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 p-6 lg:p-10 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
